
import cddPdfView from './components/cdd_vue_pdf.vue'
import CddPdf from './components/pdfView'

//插件配置
cddPdfView.install = function (Vue, options = {}) {
  Vue.component(options.name || 'cdd-pdf-view', cddPdfView)
  Vue.prototype.$CddPdf = PdfView
}

//插件自动注册
if (typeof window != 'undefined' && window.Vue) {
  Vue.component('cdd-pdf-view', cddPdfView)
  window.PdfView = PdfView
}

export {
  cddPdfView,
  CddPdf,
  CddPdf as PdfView,
}

export default {
  cddPdfView,
  CddPdf,
  pdView: CddPdf
}


